import { render, staticRenderFns } from "./pengajuanBarangRusak.vue?vue&type=template&id=7edf7f22&scoped=true&"
import script from "./pengajuanBarangRusak.js?vue&type=script&lang=js&"
export * from "./pengajuanBarangRusak.js?vue&type=script&lang=js&"
import style0 from "./pengajuanBarangRusak.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./pengajuanBarangRusak.scss?vue&type=style&index=1&id=7edf7f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edf7f22",
  null
  
)

export default component.exports